import { Box, Typography } from "@mui/material";
import React, { useState } from "react";

export default function RatingField({ question, value, onChange }: any) {
  const max = question.max_rating || 5;
  const [rating, setRating] = useState(value ?? 0);

  const handleClick = (val: any) => {
    setRating(val);
    onChange?.(val);
  };

  return (
    <Box display="flex" alignItems="center" flexWrap="wrap" gap={2} mt={2}>
      <Typography variant="body2">Nicht so gut</Typography>
      {[...Array(max)].map((_, i) => (
        <span
          key={i}
          style={{
            fontSize: 24,
            cursor: "pointer",
            marginRight: 5,
            color: i < rating ? "gold" : "grey",
          }}
          onClick={() => handleClick(i + 1)}
        >
          ★
        </span>
      ))}

      <Typography variant="body2"> Sehr gut</Typography>
    </Box>
  );
}
